/* Author:Lamiaa Moustafa
Desc: Navigation reusable component
*/

import React, { useState } from "react";
import styled from "styled-components";
import Hamburger from 'hamburger-react'
import { Link } from "react-router-dom";
import { Logo } from "./logo1st2911";
import GhostButtonAsDropdownLink from "./buttons/GhostButton";
import ReceiverSoftware from "./buttons/ReceiverSoftware";
import MyPopover from "./MyPopover";
import "../Styles/styles.scss";
// import MyPopover from "./MyPopover"

export const Nav1st2911 = () => {
  const [isNavExpanded, setIsNavMenuExpanded] = useState(false);
  
    const closeMenu = () => {      // ... and this one only
        isNavExpanded(true);    // closes it ...
    };
  return (
    <>
      <Nav>
        <Logo />
       
        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }
        >
          <ul>
          
            <li>
              <ReceiverSoftware data={{ label: "GPS Receiver Software "}} />
            </li>

            <li>
              <NavLink  onClick={closeMenu} to="/layout" activeStyle>
                Dashboard
              </NavLink>
            </li>
            <NavLink   onClick={closeMenu} className="MobileNav1" to="/accessControl">Access Control</NavLink>
            <NavLink  onClick={closeMenu} className="MobileNav2"to="/register">Register</NavLink>
            <li>
              <GhostButtonAsDropdownLink />
            </li>
            <li>
              <MyPopover/>
            </li>
          </ul>
        </div>
         <div>
        <Hamburger 
          onToggle={() => {
            setIsNavMenuExpanded(!isNavExpanded);
            // console.log(isNavExpanded);
          }}
        />

        </div>
      </Nav>
    </>
  );
};

const Nav = styled.nav`
  width: 100%;
  background: var(--orange);
  height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 7px 50px;
  z-index: 12;
  @media screen and (max-width: 768px) {
 justify-content:flex-end;
  }
`;


const NavLink = styled(Link)`
  color: var(--white);
  font-family: var(--fontFamily);
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1.2px;
  &:hover {
    color: var(--whiteGray);
    transform: scale(0.95);
    transition: all 0.5s ease-in-out;
    text-decoration: underline;
  }
  &.active {
    font-weight: var(--boldFont);
    text-decoration: underline;
  }
  /* @media screen and (max-width: 768px) {
    display: none;
  } */
`;


